// src/components/Profile.js
import React, { useEffect, useState } from 'react';
// 1. IMPORTIAMO TOAST CONTAINER E IL CSS
import { toast, ToastContainer } from 'react-toastify'; // <--- Modificato
import 'react-toastify/dist/ReactToastify.css';         // <--- Nuovo

import { db } from '../firebaseConfig';
import { doc, getDoc, updateDoc, collection, query, where, getDocs, orderBy } from 'firebase/firestore';
import { FaUserCircle, FaArrowLeft, FaBuilding, FaIdCard, FaEdit, FaSave, FaTimes, FaCalendarCheck, FaClock, FaMapMarkerAlt, FaExclamationCircle } from 'react-icons/fa';
import '../App.css';

function Profile({ user, onBack, onLogout }) {
  const [userData, setUserData] = useState(null);
  const [userBookings, setUserBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({});

  // Caricamento dati
  useEffect(() => {
    const fetchData = async () => {
      if (user) {
        try {
          setLoading(true);

          // 1. Recupera Profilo Utente
          const docRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const data = docSnap.data();
            setUserData(data);
            setEditData(data);
          }

          // 2. Recupera le Prenotazioni dell'Utente
          const q = query(
            collection(db, "bookings"),
            where("userId", "==", user.uid),
            orderBy("createdAt", "desc")
          );
          const querySnapshot = await getDocs(q);
          const bookings = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setUserBookings(bookings);

        } catch (error) {
          console.error("Errore recupero dati:", error);
          const qFallback = query(collection(db, "bookings"), where("userId", "==", user.uid));
          const snapFallback = await getDocs(qFallback);
          const bookings = snapFallback.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setUserBookings(bookings);
        }
        setLoading(false);
      }
    };
    fetchData();
  }, [user]);



  // 2. FUNZIONE HANDLECHANGE MODIFICATA CON VALIDAZIONE NUMERICA
  const handleChange = (section, field, value) => {

    // Lista dei campi che devono essere SOLO numerici
    const numberFields = ['phone', 'legalRepPhone'];

    // Se stiamo modificando un campo telefono...
    if (numberFields.includes(field)) {
      // Controlla se il valore inserito contiene SOLO numeri
      const isNumeric = /^[0-9]*$/.test(value);

      if (!isNumeric) {
        // Se c'è una lettera, mostra errore e BLOCCA l'aggiornamento
        toast.error("Inserire solo numeri in questo campo!");
        return;
      }
    }

    // Se passa il controllo (o non è un campo telefono), aggiorna lo stato normalmente
    if (section === 'personal') {
      setEditData({ ...editData, [field]: value });
    } else if (section === 'entity') {
      setEditData({
        ...editData,
        entityData: {
          ...editData.entityData,
          [field]: value
        }
      });
    }
  };

  const handleSave = async () => {
    try {
      const docRef = doc(db, "users", user.uid);
      await updateDoc(docRef, editData);
      setUserData(editData);
      setIsEditing(false);
      toast.success("Profilo aggiornato con successo!");
    } catch (error) {
      console.error("Errore aggiornamento:", error);
      toast.error("Errore durante il salvataggio.");
    }
  };

  const handleCancel = () => {
    setEditData(userData);
    setIsEditing(false);
  };

  const formatDateIT = (dateString) => {
    if (!dateString) return "";
    return dateString.split('-').reverse().join('/');
  };

  const statusColors = {
    pending: { bg: '#fff3cd', text: '#856404', label: 'IN ATTESA' },
    confirmed: { bg: '#d4edda', text: '#155724', label: 'CONFERMATA' },
    rejected: { bg: '#f8d7da', text: '#721c24', label: 'RIFIUTATA' }
  };

  const editInputStyle = {
    width: '100%', padding: '8px', margin: '5px 0',
    borderRadius: '8px', border: '1px solid #ccc',
    fontFamily: 'Poppins, sans-serif', fontSize: '14px'
  };

  if (loading) return <div style={{
    
    minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px', fontFamily: "'Poppins', sans-serif"
  }}>

    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '25px', borderRadius: '20px', backgroundColor: 'rgba(255, 255, 255, 0.5)', textAlign: 'center', gap: '15px', border: 'none', color: '#333', textDecoration: 'none', fontSize: '16px', height: '100%' }}>

      <h2>Caricamento dati Profilo...</h2>
    </div>
  </div>

  return (
    <div style={{
      
      minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px', fontFamily: "'Poppins', sans-serif"
    }}>

      {/* 3. AGGIUNTO IL TOAST CONTAINER */}
      <ToastContainer position="top-center" autoClose={3000} />

      <div className="glass-panel" style={{ width: '100%', maxWidth: '1000px', padding: '40px', borderRadius: '30px', position: 'relative' }}>

        {/* Header Profilo */}
        <div className="responsive-profile-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(0,0,0,0.1)', paddingBottom: '20px', marginBottom: '30px' }}>

          {/* BOTTONE INDIETRO */}
          <button
            onClick={onBack}
            style={{
              display: 'flex', alignItems: 'center', gap: '8px',
              background: 'white', padding: '10px 20px', borderRadius: '30px',
              border: 'none', cursor: 'pointer', fontSize: '14px', color: '#222', fontWeight: 'bold',
              boxShadow: '0 4px 10px rgba(0,0,0,0.1)', transition: 'transform 0.2s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <FaArrowLeft /> Torna alla Home
          </button>

          <div className="responsive-profile-actions" style={{ display: 'flex', gap: '10px' }}>
            {!isEditing ? (
              <button onClick={() => setIsEditing(true)} style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#222', color: 'white', border: 'none', borderRadius: '20px', padding: '8px 20px', cursor: 'pointer', fontWeight: 'bold' }}>
                <FaEdit /> Modifica Dati
              </button>
            ) : (
              <>
                <button onClick={handleCancel} style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '20px', padding: '8px 20px', cursor: 'pointer', fontWeight: 'bold' }}>
                  <FaTimes /> Annulla
                </button>
                <button onClick={handleSave} style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#28a745', color: 'white', border: 'none', borderRadius: '20px', padding: '8px 20px', cursor: 'pointer', fontWeight: 'bold' }}>
                  <FaSave /> Salva
                </button>
              </>
            )}

            {!isEditing && (
              <button onClick={onLogout} style={{ background: '#dc3545', color: 'white', border: 'none', borderRadius: '20px', padding: '8px 20px', cursor: 'pointer', fontWeight: 'bold' }}>
                Disconnetti
              </button>
            )}
          </div>
        </div>

        <div className="responsive-profile-header" style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '30px' }}>
          <FaUserCircle size={80} color="#333" />
          <div>
            <h1 style={{ margin: 0, fontSize: '32px', color: '#222' }}>{userData?.firstName} {userData?.lastName}</h1>
            <span style={{ background: '#007bff', color: 'white', padding: '4px 12px', borderRadius: '15px', fontSize: '14px', textTransform: 'capitalize' }}>
              {userData?.userType?.replace('_', ' ')}
            </span>
          </div>
        </div>

        {/* --- GRIGLIA CONTENUTO --- */}
        <div className="responsive-profile-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '30px' }}>

          {/* COLONNA SINISTRA: DATI PERSONALI */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

            {/* BOX DATI PERSONALI */}
            <div style={{ background: 'rgba(255,255,255,0.6)', padding: '20px', borderRadius: '20px', border: isEditing ? '2px solid #007bff' : 'none' }}>
              <h3 style={{ borderBottom: '2px solid #333', paddingBottom: '10px', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
                <FaIdCard /> Dati Personali
              </h3>

              <div style={{ marginBottom: '10px' }}>
                <label style={{ fontWeight: 'bold', fontSize: '12px', color: '#555' }}>Nome</label>
                {isEditing ? <input style={editInputStyle} value={editData.firstName} onChange={(e) => handleChange('personal', 'firstName', e.target.value)} /> : <p style={{ margin: 0 }}>{userData?.firstName}</p>}
              </div>

              <div style={{ marginBottom: '10px' }}>
                <label style={{ fontWeight: 'bold', fontSize: '12px', color: '#555' }}>Cognome</label>
                {isEditing ? <input style={editInputStyle} value={editData.lastName} onChange={(e) => handleChange('personal', 'lastName', e.target.value)} /> : <p style={{ margin: 0 }}>{userData?.lastName}</p>}
              </div>

              <div style={{ marginBottom: '10px' }}>
                <label style={{ fontWeight: 'bold', fontSize: '12px', color: '#555' }}>Email (Non modificabile)</label>
                <p style={{ margin: 0, color: '#777' }}>{userData?.email}</p>
              </div>

              <div style={{ marginBottom: '10px' }}>
                <label style={{ fontWeight: 'bold', fontSize: '12px', color: '#555' }}>Telefono</label>
                {isEditing ? <input style={editInputStyle} value={editData.phone} onChange={(e) => handleChange('personal', 'phone', e.target.value)} /> : <p style={{ margin: 0 }}>{userData?.phone}</p>}
              </div>

              <div style={{ marginBottom: '10px' }}>
                <label style={{ fontWeight: 'bold', fontSize: '12px', color: '#555' }}>Luogo di Nascita</label>
                {isEditing ? <input style={editInputStyle} value={editData.birthPlace} onChange={(e) => handleChange('personal', 'birthPlace', e.target.value)} /> : <p style={{ margin: 0 }}>{userData?.birthPlace}</p>}
              </div>

              <div style={{ marginBottom: '10px' }}>
                <label style={{ fontWeight: 'bold', fontSize: '12px', color: '#555' }}>Data di Nascita</label>
                {isEditing ? (
                  <input type="date" style={editInputStyle} value={editData.birthDate} onChange={(e) => handleChange('personal', 'birthDate', e.target.value)} />
                ) : (
                  <p style={{ margin: 0 }}>{formatDateIT(userData?.birthDate)}</p>
                )}
              </div>
            </div>

            {/* BOX DATI ENTE (Se presente) */}
            {userData?.entityData && (
              <div style={{ background: 'rgba(255,255,255,0.6)', padding: '20px', borderRadius: '20px', border: isEditing ? '2px solid #007bff' : 'none' }}>
                <h3 style={{ borderBottom: '2px solid #007bff', color: '#007bff', paddingBottom: '10px', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <FaBuilding /> Dati Ente
                </h3>
                <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: 'bold', fontSize: '12px', color: '#555' }}>Nome Ente</label>{isEditing ? <input style={editInputStyle} value={editData.entityData.name} onChange={(e) => handleChange('entity', 'name', e.target.value)} /> : <p style={{ margin: 0 }}>{userData.entityData.name}</p>}</div>
                <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: 'bold', fontSize: '12px', color: '#555' }}>Indirizzo</label>{isEditing ? <input style={editInputStyle} value={editData.entityData.address} onChange={(e) => handleChange('entity', 'address', e.target.value)} /> : <p style={{ margin: 0 }}>{userData.entityData.address}</p>}</div>
                <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: 'bold', fontSize: '12px', color: '#555' }}>Codice Fiscale</label>{isEditing ? <input style={editInputStyle} value={editData.entityData.cf} onChange={(e) => handleChange('entity', 'cf', e.target.value)} /> : <p style={{ margin: 0 }}>{userData.entityData.cf}</p>}</div>
                <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: 'bold', fontSize: '12px', color: '#555' }}>Email Ente</label>{isEditing ? <input style={editInputStyle} value={editData.entityData.email} onChange={(e) => handleChange('entity', 'email', e.target.value)} /> : <p style={{ margin: 0 }}>{userData.entityData.email}</p>}</div>
                <hr style={{ opacity: 0.3 }} />
                <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: 'bold', fontSize: '12px', color: '#555' }}>Legale Rappresentante</label>{isEditing ? <input style={editInputStyle} value={editData.entityData.legalRepName} onChange={(e) => handleChange('entity', 'legalRepName', e.target.value)} /> : <p style={{ margin: 0 }}>{userData.entityData.legalRepName}</p>}</div>
                <div style={{ marginBottom: '10px' }}><label style={{ fontWeight: 'bold', fontSize: '12px', color: '#555' }}>Cellulare Rap. Legale</label>{isEditing ? <input style={editInputStyle} value={editData.entityData.legalRepPhone} onChange={(e) => handleChange('entity', 'legalRepPhone', e.target.value)} /> : <p style={{ margin: 0 }}>{userData.entityData.legalRepPhone}</p>}</div>
              </div>
            )}
          </div>

          {/* COLONNA DESTRA: LE MIE RICHIESTE */}
          <div style={{ background: 'rgba(255,255,255,0.8)', padding: '25px', borderRadius: '20px', maxHeight: '80vh', overflowY: 'auto', boxShadow: 'inset 0 0 20px rgba(0,0,0,0.05)' }}>
            <h3 style={{ marginTop: 0, marginBottom: '20px', color: '#333', display: 'flex', alignItems: 'center', gap: '10px', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
              <FaCalendarCheck color="#28a745" /> Le mie Richieste
            </h3>

            {userBookings.length === 0 ? (
              <p style={{ color: '#777', textAlign: 'center', marginTop: '50px' }}>Non hai ancora effettuato prenotazioni.</p>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                {userBookings.map(booking => (
                  <div key={booking.id} style={{ background: 'white', padding: '15px', borderRadius: '15px', boxShadow: '0 4px 10px rgba(0,0,0,0.05)', borderLeft: booking.status === 'pending' ? '5px solid #ffc107' : (booking.status === 'confirmed' ? '5px solid #28a745' : '5px solid #dc3545') }}>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '10px' }}>
                      <h4 style={{ margin: 0, fontSize: '16px', color: '#222' }}>{booking.eventName}</h4>
                      <span style={{
                        background: statusColors[booking.status]?.bg,
                        color: statusColors[booking.status]?.text,
                        padding: '3px 8px', borderRadius: '10px', fontSize: '10px', fontWeight: 'bold', textTransform: 'uppercase'
                      }}>
                        {statusColors[booking.status]?.label}
                      </span>
                    </div>

                    <div style={{ fontSize: '13px', color: '#555', display: 'flex', flexDirection: 'column', gap: '5px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><FaMapMarkerAlt color="#007bff" /> {booking.spaceId}</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><FaCalendarCheck color="#007bff" /> {formatDateIT(booking.startDate)} {booking.isMultiDay ? `- ${formatDateIT(booking.endDate)}` : ''}</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><FaClock color="#007bff" /> {booking.startTime} - {booking.endTime}</div>

                      {booking.status === 'rejected' && booking.rejectionReason && (
                        <div style={{ display: 'flex', color: '#dc3545', alignItems: 'center', gap: '8px', marginTop: '5px', fontWeight: 'bold' }}>
                          <FaExclamationCircle /> Motivo Rifiuto: <span style={{ fontWeight: '1' }}> {booking.rejectionReason} </span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

        </div>

      </div>
    </div>
  );
}

export default Profile;